import type { StepOption } from '@/api/types';
import { t } from '@/i18n';

// Authority-style options carry `removable` either in `metadata` (where the API
// puts it today) or as a top-level field (legacy/fallback). Treat missing as
// `true` (i.e. user-removable).
export function getRemovable(opt: StepOption): boolean {
  // The API omits `metadata` on options that have none (StepOptionSerializer, required=False).
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const metaVal = opt.metadata?.['removable'];
  if (typeof metaVal === 'boolean') return metaVal;
  return opt.removable ?? true;
}

/**
 * Translates a stable API code via the key `<group>.<code>`. A code the widget
 * has no key for keeps `fallback`, so a new backend code still shows something.
 */
export function codeLabel(group: string, code: string, fallback: string): string {
  const key = `${group}.${code}`;
  const label = t(key);
  return label === key ? fallback : label;
}

/** Label for a custom tariff type (`fixed`, `spot`, `tou`). */
export function customTypeLabel(id: string, fallback: string): string {
  return codeLabel('steps.retailer_custom_type.types', id, fallback);
}
